/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Rapat_OkInputs */

const en_tut_rapat_ok = /** @type {(inputs: Tut_Rapat_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The meeting status becomes **Berlangsung**, the number of connected participants shows above the panel, and the transcript fills itself in on the right.`)
};

const id_tut_rapat_ok = /** @type {(inputs: Tut_Rapat_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status rapat menjadi **Berlangsung**, jumlah peserta terhubung terlihat di atas panel, dan transkrip mengisi dirinya sendiri di kolom kanan.`)
};

/**
* | output |
* | --- |
* | "The meeting status becomes **Berlangsung**, the number of connected participants shows above the panel, and the transcript fills itself in on the right." |
*
* @param {Tut_Rapat_OkInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_rapat_ok = /** @type {((inputs?: Tut_Rapat_OkInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Rapat_OkInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_rapat_ok(inputs)
	return en_tut_rapat_ok(inputs)
});